function cleanObject(obj: { [key: string]: any }): { [key: string]: any } {
  return Object.entries(obj).reduce((acc: { [key: string]: any }, [key, value]) => {
    if (value !== null && value !== undefined && value !== '') {
      // eslint-disable-next-line no-param-reassign
      acc[key] = value
    }
    return acc
  }, {})
}

export default cleanObject
